
export const BASE_YEAR_WIDTH = 60
export const BASE_MONTH_WIDTH = 20
export const BASE_DAY_WIDTH = 60

export const getDataIndexOnScroll = ({ data, target }) => {
  const dataLength = data ? data.length : 0
  const scrollPercentage = (100 * target.scrollLeft) / (target.scrollWidth - target.clientWidth)
  const currentCenter = (target.clientWidth / 2) + ((dataLength * BASE_YEAR_WIDTH * (scrollPercentage * 0.01)) / 2)
  return parseInt(currentCenter / BASE_YEAR_WIDTH, 10)
}
